module.exports = __FOREMAN_VENDOR__APOLLO_CLIENT__;